/** Mapuje linki z API (ścieżki MPA) na trasy SPA. */
export function spaLocation(href: string): { to: string } | { href: string } {
  if (!href) {
    return { href: "#" };
  }
  if (href.startsWith("#")) {
    return { href };
  }
  if (href.startsWith("/app/")) {
    return { to: href.slice("/app".length) || "/" };
  }
  if (href.startsWith("/app")) {
    return { to: "/" };
  }

  const qIndex = href.indexOf("?");
  const path = qIndex >= 0 ? href.slice(0, qIndex) : href;
  const query = qIndex >= 0 ? href.slice(qIndex) : "";

  const map: Record<string, string> = {
    "/": "/",
    "/login": "/login",
    "/register": "/register",
    "/welcome": "/welcome",
    "/privacy": "/privacy",
    "/terms": "/terms",
    "/animals": "/animals",
    "/animals/archive": "/animals/archive",
    "/animals/irz-diff": "/irz",
    "/reproduction": "/reproduction",
    "/reproduction/breeding": "/reproduction/breeding",
    "/reproduction/births": "/reproduction/births",
    "/reproduction/lambings": "/reproduction/births",
    "/reproduction/archive": "/reproduction/archive",
    "/reproduction/free-tags": "/resources",
    "/resources": "/resources",
    "/lambings": "/reproduction/births",
    "/lambings/archive": "/reproduction/archive",
    "/lambings/free-tags": "/resources",
    "/births": "/reproduction/births",
    "/births/archive": "/reproduction/archive",
    "/births/free-tags": "/resources",
    "/controls": "/controls",
    "/controls/history": "/controls/history",
    "/tag-verification": "/controls",
    "/tag-verification/history": "/controls/history",
    "/reports": "/reports",
    "/expenses": "/expenses",
    "/irz": "/irz",
    "/guide": "/guide",
    "/settings": "/settings",
    "/statistics": "/statistics",
  };

  if (path in map) {
    return { to: `${map[path]}${query}` };
  }
  if (path.startsWith("/reproduction/births/")) {
    return { to: `/reproduction/births${query}` };
  }
  return { href };
}
